import { render, staticRenderFns } from "./NavBarLocation.vue?vue&type=template&id=3bb6a1aa&"
import script from "./NavBarLocation.vue?vue&type=script&lang=ts&"
export * from "./NavBarLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports